import { Link } from "react-router-dom";

export default function HomeFiveContact(){
    return(
        <section className="contact-area pb-90 pt-md-55 pb-md-30 pt-xs-55 pb-xs-30 home-5">
			<div className="container">
				<div className="row align-items-center">
					<div className="col-lg-6">
						<div className="section-content mb-20 pl-40 pl-lg-0 pl-md-0 pl-xs-0">
							<div className="section-title mb-40">
								<h3 className="semi-title">Get in touch</h3>
								<h2 className="sect-title">Now Let's Discuss your Project</h2>
							</div>
							<p className="description">
								Mollitia incididunt class vehicula diam feugiat aptent nisl, hic mauris. Praesent nullam
								nisl excepturi habitasse viverra facilisi accusantium earum elit proident aliquet
								ultrices eos elementum
							</p>
							<div className="section-icon">
								<ul className="icon d-flex align-items-center text-start">
									<li>
										<Link to="#"><i className="fab fa-facebook-f"></i></Link>
									</li>
									<li>
										<Link to="#"><i className="fab fa-twitter"></i></Link>
									</li>
									<li>
										<Link to="#"><i className="fab fa-instagram"></i></Link>
									</li>
									<li>
										<Link to="#"><i className="fab fa-dribbble"></i></Link>
									</li>
									<li>
										<Link to="#"><i className="fab fa-pinterest"></i></Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<form className="row contact-form mb-30" action="#">
							<div className="col-lg-6 col-md-6">
								<div className="input-box mb-20">
									<input type="text" placeholder="Full name" />
								</div>
							</div>
							<div className="col-lg-6 col-md-6">
								<div className="input-box mail-input mb-20">
									<input type="text" placeholder="Email address" />
								</div>
							</div>
							<div className="col-lg-12 mb-20">
								<div className="input-box sub-input">
									<input type="text" placeholder="Subject" />
								</div>
							</div>
							<div className="col-12">
								<div className="input-box text-input mb-15">
									<textarea name="message" cols="30" rows="10" placeholder="Message"></textarea>
								</div>
							</div>

							<div className="col-12">
								<button className="form-btn form-btn2">Get A quote</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</section>
    )
}